import { laoViewsConstants } from "reduxLib/constants";
import fetch from "../serviceHelpers";
import { endpoints } from "helpers";
import i18n from '../../../i18n/i18n';

export const resetLAOViews = ({ tableName }) => dispatch => {
    dispatch({
        type: laoViewsConstants.RESET_VIEWS,
        tableName
    });
}

export const resetLAOStatus = () => dispatch => {
    dispatch({
        type: laoViewsConstants.RESET_STATUS,
    });
}

export const resetLAOViewStatus = ({ tableName }) => dispatch => {
    dispatch({
        type: laoViewsConstants.RESET_LAO_STATUS,
        tableName
    });
}

export const getAllLAOViews = ({ tableName, controller: serviceController }) => async dispatch => {
    dispatch({
        type: laoViewsConstants.VIEWS_LOADING,
        payload: true,
        tableName
    });

    return fetch(`${endpoints.lao.getviews}?appName=${tableName}`, {
        method: "GET",
        signal: serviceController?.signal
    })
        .then(response => {
            if (response.status === 200) {
                return response.json()
            }
            throw i18n.t('views_loading_failed')
        })
        .then(response => {
            const tableViewsData = response.layouts?.filter(e => e.tableName === tableName)[0] || {};
            const views = (tableViewsData.privateViews || [])
                .map(e => ({ ...e, isFav: e.id === tableViewsData.favViewID }));
            dispatch({
                type: laoViewsConstants.GET_ALL_VIEWS_SUCCESS,
                status: {
                    status: "success",
                    show: false,
                    message: "views_loaded_successfully"
                },
                payload: { views },
                tableName,
            });
        })
        .catch((e) => {
            dispatch({
                type: laoViewsConstants.GET_ALL_VIEWS_FAILED,
                status: {
                    status: "error",
                    message: e,
                    show: false,
                },
                tableName,
                payload: { views: [], activeView: {} }
            });
        });
}

export const getLAOView = ({ viewid, tableName }) => dispatch => {
    dispatch({
        type: laoViewsConstants.VIEW_LOADING,
        payload: true,
        tableName
    });

    return fetch(`${endpoints.lao.getview}?tableName=${tableName}&viewID=${viewid}`, {
        method: "GET",
    })
        .then(d => {
            if (d.status === 200) {
                return d.json();
            }
            throw "Error";
        })
        .then(d => {
            dispatch({
                type: laoViewsConstants.GET_VIEW_SUCCESS,
                status: {
                    show: false,
                    status: "success",
                    message: "get_view_success"
                },
                tableName,
                payload: d
            });

        })
        .catch(() => {
            dispatch({
                type: laoViewsConstants.GET_VIEW_FAILED,
                status: {
                    show: false,
                    status: "error",
                    message: "get_view_failed"
                },
                tableName,
                payload: {}
            });
        })
}

export const updateLAOView = ({ view, tableName, updateType = "update" }) => async dispatch => {
    dispatch({
        type: laoViewsConstants.VIEW_LOADING,
        payload: true,
        tableName
    });

    return fetch(`${endpoints.lao.updateviews}?tableName=${tableName}`, {
        method: "PUT",
        body: {
            ...view,
            tableName
        },
    })
        .then(d => {
            if (d.status === 200) {
                dispatch({
                    type: laoViewsConstants.INSERT_UPDATE_VIEW_SUCCESS,
                    status: {
                        show: true,
                        status: "success",
                        message: "view_created_updated_success"
                    },
                    tableName,
                    updateType,
                    payload: view
                });
            } else {
                throw "Error";
            }
        })
        .catch((e) => {
            dispatch({
                type: laoViewsConstants.INSERT_UPDATE_VIEW_FAILED,
                status: {
                    show: true,
                    status: "error",
                    message: "view_creation_updation_failed"
                },
                tableName,
                updateType,
                payload: {}
            });
        })
}

export const deleteLAOView = ({ viewid, tableName }) => dispatch => {
    dispatch({
        type: laoViewsConstants.VIEW_LOADING,
        payload: true,
        tableName
    });

    return fetch(`${endpoints.lao.deleteView}?tableName=${tableName}&viewID=${viewid}`, {
        method: "DELETE",
    })
        .then(d => {
            if (d.status === 200) {
                dispatch({
                    type: laoViewsConstants.DELETE_VIEW_SUCCESS,
                    status: {
                        status: "success",
                        show: true,
                        message: "view_deleted_success"
                    },
                    tableName,
                    payload: viewid
                });
            } else {
                throw "Error";
            }
        })
        .catch(() => {
            dispatch({
                type: laoViewsConstants.DELETE_VIEW_FAILED,
                status: {
                    status: "error",
                    show: true,
                    message: "view_deleted_failed"
                },
                tableName,
                payload: null
            });
        })
}

export const favUnfavLAOView = ({ viewid, tableName, isFav, method }) => dispatch => {
    dispatch({
        type: laoViewsConstants.VIEW_LOADING,
        payload: true,
        tableName
    });

    return fetch(`${endpoints.lao.favView}?tableName=${tableName}`, {
        method: "PUT",
        body: {
            id: method === "fav" ? viewid: "",
            tableName: tableName
        }
    })
        .then(d => {
            if (d.status === 200) {
                dispatch({
                    type: laoViewsConstants.FAV_UNFAV_VIEW_SUCCESS,
                    status: {
                        status: "success",
                        show: true,
                        message: "view_fav_unfav_success"
                    },
                    tableName,
                    isFav,
                    payload: viewid
                });
            } else {
                throw "Error"
            }
        })
        .catch(() => {
            dispatch({
                type: laoViewsConstants.FAV_UNFAV_VIEW_FAILED,
                status: {
                    status: "error",
                    show: true,
                    message: "view_fav_unfav_failed"
                },
                tableName,
                payload: null
            });
        });
}
